import {Fragment} from "preact";
import {Dialog, Transition} from "@headlessui/react";
import Content from "./Content";
import {useSatisfactionSurvey} from "./useSatisfactionSurvey";
import s from "./satisfactionSurvey.module.css";
import {useAppContext} from "../../contexts";
import {modalCloseIcon} from "../../assets";

const SatisfactionSurvey = (props) => {
    // Destructured props
    const {
        open,
        setOpen
    } = props;

    // Component logic data
    const componentProps = useSatisfactionSurvey();

    // Destructured component logic data
    const {
        isExpanded,
        handleExpandAction
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // The variable name says it all
    const closeButton = (
        <button
            type={"button"}
            className={`${s.closeButtonRoot} ${highContrast ? s.dmCloseButtonRoot : ""}`}
            onClick={() => setOpen(false)}
        >
            <img
                src={modalCloseIcon}
                alt="Close icon"
            />
        </button>
    )

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto overflow-x-hidden">
                    <div className={
                        `flex min-h-full items-center justify-center text-center sm:items-center transition-all duration-300 sm:p-0 ${!isExpanded ? "p-4" : "p-0"}`
                    }>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className={
                                `${s.dialogPanel} ${highContrast ? "bg-[#2f2f2f]" : "bg-light-gray"} ${!isExpanded ? s.isNarrowed : s.isExpanded}`
                            }>
                                <Content handleExpandAction={handleExpandAction} />
                                {closeButton}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default SatisfactionSurvey;
